import type { GQL } from "@binale-tech/shared";
import type { DmsType } from "@domain/models/dms";
import type { DmsDefaultSubType, DmsTaxeSubType, UploadFileStatus } from "@dms/types/Enums";
import type { DmsTableCols, ExcludedColsFromSetting } from "@dms/modules/DocumentTableModule/consts";
import type { ReviewStatus } from "@dms/modules/DocumentTableModule/components/CellRendererDocumentReview/CellRendererDocumentReview";
import type { PaymentStatus } from "@ui-components/hooks/usePaymentStatus";

export const FILTER_EMPTY_VALUE = "__empty__" as const;

export enum FilterAttachedValues {
    All = "all",
    Attached = "attached",
    NotAttached = "notAttached",
}

/** Mirrors the "Art" table column: string values match CashflowType so the mapping stays trivial. */
export enum FilterAmountType {
    All = "all",
    Aufwand = "spending",
    Ertrag = "receipt",
    Anhang = "attachment",
}

export enum FilterAiStatus {
    All = "all",
    Progress = "progress",
    Success = "success",
    Error = "error",
}

export type TFilterConfigItem = Partial<{
    year: string;
    month: number;
    filterDraft: null | GQL.IDocumentStatus;
    filterReview: null | ReviewStatus | typeof FILTER_EMPTY_VALUE;
    filterPayment: null | PaymentStatus | typeof FILTER_EMPTY_VALUE;
    filterColor: null | GQL.IDocumentColors;
    filterAttached: null | FilterAttachedValues;
    filterAccountingProductKey: null | GQL.IProductKey;
    filterTransactionAttached: null | FilterAttachedValues;
    filterCashRegisterAttached: null | FilterAttachedValues;
    filterAiStatus: null | FilterAiStatus;
    filterContact: null | string;
    filterAmountType: null | FilterAmountType;
    isCheckboxSelected: boolean;
    sortState: TSortState[];
    filterState: TableOnChangeFilters;
    paginationState: {
        pageSize: TPaginationPageSize;
        currentPage: number;
    };
    modalModeConfig: Partial<{
        sortState: TSortState;
        filterState: TableOnChangeFilters;
    }>;
}>;

export type TDmsTableCols = (typeof DmsTableCols)[keyof typeof DmsTableCols];

export type TExcludedColsFromSetting = (typeof ExcludedColsFromSetting)[number];

export type TSortState = {
    colId: TDmsTableCols;
    sort: "asc" | "desc" | null;
};

export type TPaginationPageSize = 50 | 100 | 1000;

export type TableOnChangeFilters = Record<string, (string | number | boolean)[] | null>;

export type TUploadFile = {
    file: File;
    hash: string;
    status?: UploadFileStatus;
    isUploaded?: boolean;
    error?: false | string;
};

export type TBindSubType = DmsType.Bank | DmsType.KB;
export type TEditingSubType = DmsType.Bank | DmsType.KB;

export type DmsTypeOption = {
    value?: DmsType;
    isDivider?: boolean;
    translationKey?: string;
    isGroup?: boolean;
    defaultSubtypes?: TDmsSubTypeOption[];
};
export type TDmsTaxesOptions = { value?: DmsTaxeSubType; translationKey?: string };
export type TDmsSubTypeOption = { value?: DmsDefaultSubType; translationKey?: string };

export type { IDocumentSuggestion } from "@domain/models/dms";
